import { render, staticRenderFns } from "./view-product-detail-report.vue?vue&type=template&id=75cfaf98&"
import script from "./view-product-detail-report.vue?vue&type=script&lang=js&"
export * from "./view-product-detail-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports